import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChallengeInfo } from "../types/core";
import { pingFrame } from "../actions/sharedActions";

export interface Challenge extends ChallengeInfo {
  headers: Record<string, string>;
}

export interface ChallengeState {
  data: Record<string, Challenge>;
}

const initialState: ChallengeState = {
  data: {},
};

const challengeSlice = createSlice({
  name: "challenge",
  initialState,
  reducers: {
    setChallengeHeadersAndPing: (
      state,
      action: PayloadAction<{
        frameId: string;
        headers: Record<string, string>;
      }>
    ) => {
      const { frameId, headers } = action.payload;
      state.data[frameId] = {
        ...(state.data[frameId] || {}),
        headers,
      };
    },
  },
  extraReducers: (builder) =>
    builder.addCase(pingFrame.fulfilled, (state, action) => {
      const { frame_id } = action.meta.arg;
      state.data[frame_id] = {
        // We need to add headers if missing, we need to merge if re-ping, we need to pass new data
        ...(state.data[frame_id] || { headers: {} }),
        ...action.payload.data.challenge,
      };
    }),
});
export const { setChallengeHeadersAndPing } = challengeSlice.actions;
export const challengeReducer = challengeSlice.reducer;
